import React from 'react';
import styled from 'styled-components';
import { SPACING, MEDIA_QUERIES } from '@govuk-react/constants';
import { BLUE, WHITE } from 'govuk-colours';
import { asAnchor } from '@govuk-react/hoc';
import {
    Main,
    GridRow,
    GridCol,
    Paragraph,
    Header,
    ListItem,
    Button,
    ListNavigation,
    InsetText,  MultiChoice, Radio
} from 'govuk-react';
import { ButtonArrow } from '@govuk-react/icons';
// import {Field} from "react-final-form";
import PropTypes from "prop-types";

const AnchorTag = asAnchor('a');

const Introduction = styled('div')({
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_2
});

const Example = styled('div')({
    borderTop: 'solid 1px #bfc1c3',
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_2
});

const CustomStyledButton = styled(Button)({
    backgroundColor: WHITE,
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: BLUE,
    color: BLUE,
    ':hover': {
        backgroundColor: BLUE,
        color: WHITE
    }
});

const CustomListItem = styled(ListItem)({
    fontSize: '44px',
    [MEDIA_QUERIES.LARGESCREEN]: {
        fontSize: '24px'
    }
});



const RadioGroup = ({
                        label, hint, options, inline, input, meta,
                    }) => (
    <div>
        <MultiChoice label={label} hint={hint} meta={meta}>
            {options.map(o => (
                <Radio
                    key={o.value}
                    {...input}
                    value={o.value}
                    inline={inline}
                    checked={o.value === input.value}
                >
                    {o.title}
                </Radio>
            ))}
        </MultiChoice>
    </div>
);

RadioGroup.defaultProps = {
    input: {},
    meta: {},
    hint: undefined,
    inline: false,
    options: {},
};

RadioGroup.propTypes = {
    input: PropTypes.shape({}),
    meta: PropTypes.shape({}),
    label: PropTypes.string.isRequired,
    hint: PropTypes.string,
    inline: PropTypes.bool,
    options: PropTypes.shape({
        title: PropTypes.string,
        value: PropTypes.string,
    }),
};

const CustomElementsTwo = () => (
    <Main>
        <GridRow>
            <GridCol columnTwoThirds>
                <Introduction>
                    <Header level={1}>Custom elements 2</Header>
                    {/*<LeadParagraph>*/}
                    {/*    Duis aute irure dolor in reprehenderit in voluptate*/}
                    {/*</LeadParagraph>*/}
                    <Paragraph>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
                    </Paragraph>
                    <InsetText>
                        <Paragraph mb={0}>
                            Nulla tellus felis, interdum nec facilisis et, condimentum ut mauris.
                        </Paragraph>
                    </InsetText>
                </Introduction>
                <Example>
                    <Header level={2}>Buttons</Header>
                    <ListNavigation listStyleType="square" mb={4}>
                        <AnchorTag
                            target="_blank"
                            href="https://ukhomeoffice.github.io/govuk-react/?knob-Children=Button&knob-level=6&knob-Disabled=false&knob-Start=false&selectedKind=Form%2FButtons&selectedStory=Component%20Default&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel"
                        >
                            Nam non augue quis libero vestibulum viverra ut id ante.
                        </AnchorTag>
                        <AnchorTag
                            target="_blank"
                            href="https://github.com/UKHomeOffice/govuk-react/blob/master/components/button/src/index.js"
                        >
                            Etiam tincidunt nisi ac fringilla pulvinar.
                        </AnchorTag>
                    </ListNavigation>
                    <Button>Original button</Button>
                    <CustomStyledButton>Customised button</CustomStyledButton>
                    <Paragraph>
                        Nam in enim posuere, gravida dolor nec, consectetur ligula. Ut non vehicula turpis. Quisque sodales vestibulum turpis, ut imperdiet nisi mollis vitae.
                        [Aliquam consectetur porta](http://ontario.ca).
                    </Paragraph>
                    <CustomStyledButton start>Customised button</CustomStyledButton>
                    <CustomStyledButton start icon={<ButtonArrow />}>
                        Customised button
                    </CustomStyledButton>
                </Example>
                <Example>
                    <Header level={2}>List items</Header>
                    <ListItem>Etiam accumsan</ListItem>
                    <CustomListItem>Pellentesque</CustomListItem>
                </Example>
            </GridCol>
        </GridRow>
    </Main>
);

export default CustomElementsTwo;
